import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Create,
    GetAllCandidates,
} from "adminApi/CandidateInterviewApi/CandidateInterview";
import { validateForm } from "utils/validation";
import { CandidateInterviewRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddCandidateInterviewForm from "./components/AddCandidateInterviewForm";
import fields from "../json/CandidateInterview.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const AddCandidateInterview = () => {

    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    // HandleInputChange
    const { values, errors, handleChange, setErrors } = useFormChange(
        initialValues,
        CandidateInterviewRules
    );

    // Fetch shortlisted candidates for dropdown
    const { data: CandidateOptions = [] } = useFetchAllData(GetAllCandidates);

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Create({ data: formData });
        },
        (vals) => {
            const err = validateForm(vals, CandidateInterviewRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Interview Created Successfully"
    );

    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddCandidateInterviewForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Create Candidate Interview"
                CandidateOptions={CandidateOptions}
            />
        </>
    );
};

export default AddCandidateInterview;
